<app-temp-modal-cadastro #modalCadastro (closed)="onClose()" [textHeader]="textHeader">
  <form [formGroup]="cadastroForm" (ngSubmit)="submitForm()">
    <div class="row">
      <div class="form-group col-sm-12">
        <label for="form_descricao" class="label-required">Descrição</label>
        <input id="form_descricao" [disableControl]="loading['registro']" type="text" class="form-control" formControlName="descricao"/>
        <show-errors [control]="cadastroForm.controls.descricao"></show-errors>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-sm-12">
        <label for="form_percentualComissaoCobranca">Comissão cobrança</label>
        <input id="form_percentualComissaoCobranca" [disableControl]="loading['registro']" type="number" class="form-control"
          formControlName="percentualComissaoCobranca" />
        <show-errors [control]="cadastroForm.controls.percentualComissaoCobranca"></show-errors>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-sm-12">
        <label for="form_percentualComissaoFaturamento">Comissão faturamento</label>
        <input id="form_percentualComissaoFaturamento" [disableControl]="loading['registro']" type="number" class="form-control"
          formControlName="percentualComissaoFaturamento" />
        <show-errors [control]="cadastroForm.controls.percentualComissaoFaturamento"></show-errors>
      </div>
    </div>

    <div class="alert alert-danger" *ngIf="errors">
      <span>{{ errors }}</span>
    </div>

    <button [disabled]='loading["registro"]' type="submit" (click)="validaForm()" class="btn btn-primary ripple light">
      <app-loading [texto]="'Salvar'" [loading]="loading['registro']"></app-loading>
    </button>
    <button [disabled]='loading["registro"]' type="button" class="btn btn-default ripple"
      (click)="modalCadastro.hide()">Cancelar</button>
  </form>
</app-temp-modal-cadastro>


<app-abrir-modal #abrirModal></app-abrir-modal>
